import { cn } from '../../../lib/cn';
import ProgressBar from './ProgressBar';

export default function SessionShell({
  children,
  progress,
  progressSections,
  onSegmentClick,
  topLabel,
  topRight,
  className,
}) {
  // Callers decide whether to render a top label. Onboarding interactive
  // passes null (the sectioned bar's labels are self-explanatory); the
  // observer mirror passes "Watching · X"; review passes "X words remaining"
  // alongside its single-section bar.
  const showTopLabel = Boolean(topLabel);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 flex flex-col">
      {/* Top bar */}
      <div className="flex-shrink-0 px-4 pt-4 pb-2 max-w-2xl w-full mx-auto">
        <div className="flex items-center justify-between mb-2 min-h-[1.25rem]">
          {showTopLabel ? (
            <span className="text-sm text-gray-500 dark:text-gray-400 font-medium">
              {topLabel}
            </span>
          ) : (
            <span />
          )}
          {topRight}
        </div>
        {progressSections && progressSections.length > 0 ? (
          <ProgressBar sections={progressSections} onSegmentClick={onSegmentClick} />
        ) : progress ? (
          <ProgressBar current={progress.current} total={progress.total} />
        ) : null}
      </div>

      {/* Center content */}
      <div
        className={cn(
          'flex-1 flex items-start justify-center px-4 py-8',
          className
        )}
      >
        <div className="w-full max-w-2xl">{children}</div>
      </div>
    </div>
  );
}
